if (!customElements.get("quick-add-modal")) {
    customElements.define(
        "quick-add-modal",
        class QuickAddModal extends ModalDialog {
            constructor() {
                super();
                this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
            }

            hide(preventFocus = false) {
                const cartNotification =
                    document.querySelector("cart-notification") ||
                    document.querySelector("cart-drawer");
                if (cartNotification)
                    cartNotification.setActiveElement(this.openedBy);
                this.modalContent.innerHTML = "";

                if (preventFocus) this.openedBy = null;
                super.hide();
            }

            show(opener) {
                opener.setAttribute("aria-disabled", true);
                opener.classList.add("loading");
                opener
                    .querySelector(".loading-overlay__spinner")
                    .classList.remove("hidden");

                fetch(opener.getAttribute("data-product-url"))
                    .then((response) => response.text())
                    .then((responseText) => {
                        const responseHTML = new DOMParser().parseFromString(
                            responseText,
                            "text/html"
                        );
                        this.productElement = responseHTML.querySelector(
                            'section[id^="MainProduct-"]'
                        );
                        this.preventDuplicatedIDs();
                        this.removeDOMElements();
                        this.setInnerHTML(
                            this.modalContent,
                            this.productElement.innerHTML
                        );

                        // Setup vendor validation for modal
                        setTimeout(() => {
                            this.setupVendorValidation(opener);
                        }, 100);

                        if (window.Shopify && Shopify.PaymentButton) {
                            Shopify.PaymentButton.init();
                        }

                        if (window.ProductModel)
                            window.ProductModel.loadShopifyXR();

                        this.removeGalleryListSemantic();
                        this.updateImageSizes();
                        this.preventVariantURLSwitching();
                        super.show(opener);
                    })
                    .finally(() => {
                        opener.removeAttribute("aria-disabled");
                        opener.classList.remove("loading");
                        opener
                            .querySelector(".loading-overlay__spinner")
                            .classList.add("hidden");
                    });
            }

            //  vendor validation for quick-add modal
            setupVendorValidation(opener) {
                const productForm =
                    this.modalContent.querySelector("product-form form");
                const submitButton = this.modalContent.querySelector(
                    'product-form [type="submit"]'
                );

                if (!productForm || !submitButton) return;

                // Get vendor data from opener button
                const productVendor = opener.getAttribute("vendor");
                const productId = opener.getAttribute("product-id");
                const productHandle = opener.getAttribute("product-handle");

                console.log("Setting up vendor validation for modal:", {
                    productVendor,
                    productId,
                });

                // Remove existing submit handler and add our custom one
                const originalSubmitHandler = productForm.onsubmit;
                productForm.onsubmit = null;

                // Create our vendor validation handler
                const vendorValidationHandler = async (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();

                    console.log("Quick-add modal: Vendor validation triggered");

                    // Get form data
                    const formData = new FormData(productForm);
                    const variantId = formData.get("id") || productId;
                    const quantity = formData.get("quantity") || 1;
                    const vendor = productVendor;

                    if (!vendor) {
                        console.log("No vendor found, proceeding normally");
                        this.proceedWithNormalSubmit(productForm, formData);
                        return;
                    }

                    try {
                        // Check cart compatibility
                        const shouldProceed =
                            await this.checkVendorCompatibility(
                                vendor,
                                variantId,
                                quantity,
                                productHandle
                            );

                        if (shouldProceed) {
                            // Vendor validation passed or cart was cleared
                            this.proceedWithNormalSubmit(productForm, formData);
                        } else {
                            console.log(
                                "User cancelled vendor validation - not proceeding"
                            );
                            // User cancelled - explicitly do nothing and don't submit
                            return false;
                        }
                    } catch (error) {
                        console.error("Error in vendor validation:", error);
                        // On error, proceed normally
                        this.proceedWithNormalSubmit(productForm, formData);
                    }
                };

                // Attach our handler to the form
                productForm.addEventListener("submit", vendorValidationHandler);

                // Also attach to submit button click for safety with more aggressive prevention
                submitButton.addEventListener("click", (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();

                    // Manually trigger our validation handler
                    vendorValidationHandler(e);
                });
            }

            // Check vendor compatibility
            async checkVendorCompatibility(
                productVendor,
                variantId,
                quantity,
                productHandle
            ) {
                return new Promise((resolve) => {
                    fetch("/cart.js")
                        .then((res) => res.json())
                        .then((data) => {
                            const cartVendors = new Set(
                                data.items.map((item) => item.vendor)
                            );
                            console.log("Current cart vendors:", cartVendors);
                            console.log("Product vendor:", productVendor);

                            // If cart is empty, proceed normally
                            if (cartVendors.size === 0) {
                                console.log("Cart is empty - proceeding");
                                resolve(true);
                                return;
                            }

                            // Check for vendor conflict first
                            if (!cartVendors.has(productVendor)) {
                                // Different vendor detected
                                const userConfirmed = confirm(
                                    "Adding this item will clear your cart. Are you sure you want to continue?"
                                );
                                console.log(
                                    "User confirmation result:",
                                    userConfirmed
                                );

                                if (userConfirmed) {
                                    // User confirmed, clear cart and add product
                                    this.clearCartAndAddProduct(
                                        variantId,
                                        quantity,
                                        productVendor
                                    )
                                        .then(() => {
                                            alert(
                                                `Your cart has been cleared. You can now add products from the vendor "${productVendor}" to your cart.`
                                            );
                                            // Close modal and reload
                                            this.hide();
                                            location.reload();
                                            resolve(false); // Don't proceed with normal flow
                                        })
                                        .catch((error) => {
                                            console.error(
                                                "Error clearing cart:",
                                                error
                                            );
                                            resolve(true); // Proceed normally on error
                                        });
                                } else {
                                    // User cancelled - explicitly return false
                                    console.log(
                                        "User cancelled - returning false"
                                    );
                                    resolve(false);
                                }
                            } else {
                                // Same vendor - now check for local/global tag conflicts
                                this.checkTagConflicts(
                                    data,
                                    variantId,
                                    quantity,
                                    productVendor,
                                    productHandle
                                )
                                    .then((shouldProceed) => {
                                        resolve(shouldProceed);
                                    })
                                    .catch((error) => {
                                        console.error(
                                            "Error checking tag conflicts:",
                                            error
                                        );
                                        resolve(true); // Proceed normally on error
                                    });
                            }
                        })
                        .catch((error) => {
                            console.error("Error checking cart:", error);
                            resolve(true); // Proceed normally on error
                        });
                });
            }

            // Check tag conflicts
            async checkTagConflicts(
                cartData,
                variantId,
                quantity,
                productVendor,
                productHandle
            ) {
                try {
                    // If no productHandle provided, try to extract it
                    if (!productHandle) {
                        // Get current product's handle from the modal content
                        const productElement =
                            this.modalContent.querySelector(
                                "[data-product-url]"
                            ) || this.modalContent.querySelector(".product");

                        if (
                            productElement &&
                            productElement.dataset.productUrl
                        ) {
                            productHandle =
                                productElement.dataset.productUrl.split(
                                    "/products/"
                                )[1];
                        } else {
                            // Try to get from the original opener button
                            const opener = document.querySelector(
                                `[product-id="${variantId}"]`
                            );
                            if (
                                opener &&
                                opener.getAttribute("product-handle")
                            ) {
                                productHandle =
                                    opener.getAttribute("product-handle");
                            }
                        }
                    }

                    if (!productHandle) {
                        console.log(
                            "Could not determine product handle, proceeding normally"
                        );
                        return true;
                    }

                    console.log(
                        "Checking tag conflicts for handle:",
                        productHandle
                    );

                    // Get current product's tags
                    const currentProductResponse = await fetch(
                        `/products/${productHandle}.js`
                    );
                    const currentProduct = await currentProductResponse.json();
                    const currentProductTags = currentProduct.tags;
                    const currentHasLocal =
                        currentProductTags.includes("local");
                    const currentHasGlobal =
                        currentProductTags.includes("global");

                    console.log("Current product tags:", currentProductTags);
                    console.log(
                        "Has local:",
                        currentHasLocal,
                        "Has global:",
                        currentHasGlobal
                    );

                    // If current product has neither local nor global tags, no conflict possible
                    if (!currentHasLocal && !currentHasGlobal) {
                        console.log(
                            "No local/global tags found, proceeding normally"
                        );
                        return true;
                    }

                    // Get all cart items' product details to check their tags
                    const productRequests = cartData.items.map((item) =>
                        fetch(`/products/${item.handle}.js`).then((res) =>
                            res.json()
                        )
                    );

                    const cartProducts = await Promise.all(productRequests);
                    let hasTagConflict = false;

                    // Check each cart item for tag conflicts
                    cartData.items.forEach((item, index) => {
                        const cartItemTags = cartProducts[index].tags;
                        const cartHasLocal = cartItemTags.includes("local");
                        const cartHasGlobal = cartItemTags.includes("global");

                        console.log(
                            `Cart item ${item.title} tags:`,
                            cartItemTags
                        );

                        // Check for conflicts:
                        // 1. Current product is local, cart item is global
                        // 2. Current product is global, cart item is local
                        if (
                            (currentHasLocal && cartHasGlobal) ||
                            (currentHasGlobal && cartHasLocal)
                        ) {
                            hasTagConflict = true;
                            console.log("Tag conflict detected!");
                        }
                    });

                    if (hasTagConflict) {
                        const userConfirmed = confirm(
                            "We do not allow purchase of local and global products at the same time. Proceeding will remove the previous products. Are you sure you want to continue?"
                        );
                        console.log(
                            "Tag conflict - User confirmation result:",
                            userConfirmed
                        );

                        if (userConfirmed) {
                            // User confirmed, clear cart and add product
                            await this.clearCartAndAddProduct(
                                variantId,
                                quantity,
                                productVendor
                            );
                            alert(
                                `Your cart has been cleared. You can now add products from the vendor "${productVendor}" to your cart.`
                            );
                            // Close modal and reload
                            this.hide();
                            location.reload();
                            return false; // Don't proceed with normal flow
                        } else {
                            // User cancelled
                            console.log(
                                "User cancelled tag conflict - returning false"
                            );
                            return false;
                        }
                    } else {
                        // No tag conflict, safe to proceed
                        console.log(
                            "No tag conflicts found, proceeding normally"
                        );
                        return true;
                    }
                } catch (error) {
                    console.error("Error in tag conflict checking:", error);
                    return true; // Proceed normally on error
                }
            }

            // Clear cart and add product
            async clearCartAndAddProduct(variantId, quantity, vendor) {
                try {
                    // Clear cart
                    await fetch("/cart/clear.js", { method: "POST" });

                    // Add product
                    const response = await fetch("/cart/add.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                        },
                        body: `quantity=${quantity}&id=${variantId}`,
                    });

                    return await response.json();
                } catch (error) {
                    console.error("Error in cart operations:", error);
                    throw error;
                }
            }

            // Proceed with normal Shopify form submission
            async proceedWithNormalSubmit(form, formData) {
                console.log("Proceeding with normal form submission");

                // Create a proper form submission
                const submitButton = form.querySelector('[type="submit"]');

                if (submitButton) {
                    submitButton.setAttribute("aria-disabled", true);
                    submitButton.classList.add("loading");
                    const spinner = form.querySelector(
                        ".loading-overlay__spinner"
                    );
                    if (spinner) spinner.classList.remove("hidden");
                }

                try {
                    // Extract the essential data
                    const variantId = formData.get("id");
                    const quantity = formData.get("quantity") || 1;

                    console.log("Adding product:", { variantId, quantity });

                    // Add product using cart api
                    const response = await fetch("/cart/add.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                        },
                        body: `quantity=${quantity}&id=${variantId}`,
                    });

                    const result = await response.json();
                    console.log("Product added successfully:", result);

                    // Close modal and reload to update cart
                    this.hide();
                    location.reload();
                } catch (error) {
                    console.error("Error adding product:", error);
                    alert("Error adding product to cart");
                } finally {
                    if (submitButton) {
                        submitButton.classList.remove("loading");
                        submitButton.removeAttribute("aria-disabled");
                        const spinner = form.querySelector(
                            ".loading-overlay__spinner"
                        );
                        if (spinner) spinner.classList.add("hidden");
                    }
                }
            }

            setInnerHTML(element, html) {
                element.innerHTML = html;

                // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
                element.querySelectorAll("script").forEach((oldScriptTag) => {
                    const newScriptTag = document.createElement("script");
                    Array.from(oldScriptTag.attributes).forEach((attribute) => {
                        newScriptTag.setAttribute(
                            attribute.name,
                            attribute.value
                        );
                    });
                    newScriptTag.appendChild(
                        document.createTextNode(oldScriptTag.innerHTML)
                    );
                    oldScriptTag.parentNode.replaceChild(
                        newScriptTag,
                        oldScriptTag
                    );
                });
            }

            preventVariantURLSwitching() {
                const variantPicker = this.modalContent.querySelector(
                    "variant-radios,variant-selects"
                );
                if (!variantPicker) return;

                variantPicker.setAttribute("data-update-url", "false");
            }

            removeDOMElements() {
                const pickupAvailability = this.productElement.querySelector(
                    "pickup-availability"
                );
                if (pickupAvailability) pickupAvailability.remove();

                const productModal =
                    this.productElement.querySelector("product-modal");
                if (productModal) productModal.remove();

                const modalDialog =
                    this.productElement.querySelectorAll("modal-dialog");
                if (modalDialog) modalDialog.forEach((modal) => modal.remove());
            }

            preventDuplicatedIDs() {
                const sectionId = this.productElement.dataset.section;
                this.productElement.innerHTML =
                    this.productElement.innerHTML.replaceAll(
                        sectionId,
                        `quickadd-${sectionId}`
                    );
                this.productElement
                    .querySelectorAll(
                        "variant-selects, variant-radios, product-info"
                    )
                    .forEach((element) => {
                        element.dataset.originalSection = sectionId;
                    });
            }

            removeGalleryListSemantic() {
                const galleryList = this.modalContent.querySelector(
                    '[id^="Slider-Gallery"]'
                );
                if (!galleryList) return;

                galleryList.setAttribute("role", "presentation");
                galleryList
                    .querySelectorAll('[id^="Slide-"]')
                    .forEach((li) => li.setAttribute("role", "presentation"));
            }

            updateImageSizes() {
                const product = this.modalContent.querySelector(".product");
                const desktopColumns =
                    product.classList.contains("product--columns");
                if (!desktopColumns) return;

                const mediaImages = product.querySelectorAll(
                    ".product__media img"
                );
                if (!mediaImages.length) return;

                let mediaImageSizes =
                    "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

                if (product.classList.contains("product--medium")) {
                    mediaImageSizes = mediaImageSizes.replace("715px", "605px");
                } else if (product.classList.contains("product--small")) {
                    mediaImageSizes = mediaImageSizes.replace("715px", "495px");
                }

                mediaImages.forEach((img) =>
                    img.setAttribute("sizes", mediaImageSizes)
                );
            }
        }
    );
}
